<template>
	<div class="bottom">
		<div class="info">

			<template v-if="!empty">
				<div class="line">
					<span>Subtotal:</span><span>{{subtotal}}</span>
				</div>
				<div class="line">
					<span>Moms:</span><span>{{tax}}</span>
				</div>
				<div class="line">
					<span>Fragt:</span><span>{{shipping}}</span>
				</div>
			</template>

			<div class="line total">
				<span>Total inkl. moms:</span><span>DKK&nbsp;&nbsp;&nbsp;{{total}}</span>
			</div>
		</div>

		<router-link class="button" :class="{disabled: empty}" :to="{name: 'cart'}">Bestil</router-link>
	</div>
</template>

<script>
export default {
	computed: {
		data: (t) => t.$store.getters["cart/data"],
		subtotal: (t) => t.data.subtotal_price,
		tax: (t) => t.data.total_tax,
		shipping: (t) => t.data.total_shipping_price,
		total: (t) => t.data.total_price,
		empty: (t) => t.data.line_items.length === 0
	}
};
</script>

<style lang="scss" scoped>
.bottom {
	color: $white1;
	padding: 1.4em em(40);

	.info {
		font-size: em(12);

		.line {
			margin-bottom: 0.6em;
			font-weight: 300;
			display: flex;
			justify-content: space-between;

			@include res(xsmall) {
				&:not(:last-child) {
					display: none;
				}
			}

			&.total {
				span {
					&:last-child {
						font-weight: 500;
					}
				}
			}
		}
	}

	.button {
		user-select: none;
		box-shadow: 0 1px 0 0 rgba(22, 29, 37, 0.10000000149011612), inset 0 1px 0 1px rgba(255, 255, 255, 0.05999999865889549);
		margin-top: 1em;
		display: flex;
		align-items: center;
		justify-content: center;
		outline: none;
		width: 100%;
		height: 36px;
		font-size: 14px;
		background: #1A1919;
		color: $white1;
		font-weight: 500;
		letter-spacing: 1px;
		border-radius: 3px;

		&.disabled {
			opacity: 0.4;
			pointer-events: none;
		}
	}
}
</style>
